/**
 * @fileoverview GET handler for the "/custom_objects/user_custom_object_type_relationships" endpoint.
 * Returns the user→custom object relationship types for a given custom object type.
 */
import fetch from "@lib/fetch";

import { buildCustomObjectsQueryParams } from "../customObjectsShared/buildQueryParams";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsUserCustomObjectTypeRelationships } from "./constants";
import type {
  GetCustomObjectsUserCustomObjectTypeRelationshipsParams,
  GetCustomObjectsUserCustomObjectTypeRelationshipsResult,
} from "./types";
import { isGetCustomObjectsUserCustomObjectTypeRelationshipsResult } from "./validators";

export const getCustomObjectsUserCustomObjectTypeRelationships = reactQueryFetcherAdapter(
  customObjectsUserCustomObjectTypeRelationships,
  (
    signal: AbortSignal,
    params: GetCustomObjectsUserCustomObjectTypeRelationshipsParams
  ): Promise<GetCustomObjectsUserCustomObjectTypeRelationshipsResult> => {
    return fetch(
      "/custom_objects/user_custom_object_type_relationships",
      "GET",
      buildCustomObjectsQueryParams(params),
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetCustomObjectsUserCustomObjectTypeRelationshipsResult
);
